export default __webpack_public_path__ + "static/media/nodejs.bd034ffb.svg";